import { useEffect, useRef } from 'react';

import {
	StyledScrollWithSelected,
	Wrapper,
} from '~widgets/BotWizard/ui/ScrollWithSelected/styles';

export const ScrollWithSelected = <T extends { key: string }>({
	array,
	template,
	selected,
	gap = 16,
	className,
}: {
	array: T[];
	gap?: number;
	selected: (item: T) => boolean;
	template: (item: T, selected: boolean, index: number) => React.ReactNode;
	className?: string;
}) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const sel = array.findIndex((e) => selected(e));
		const containerWidth =
			containerRef.current?.getBoundingClientRect().width ?? 0;
		const itemWidth =
			containerRef.current?.children[0].children[0].getBoundingClientRect()
				.width ?? 0;
		containerRef.current?.scrollTo({
			left:
				(itemWidth + gap) * sel -
				containerWidth / 2 +
				itemWidth / 2 +
				gap * 1.5,
		});

		// do it once
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<StyledScrollWithSelected
			ref={containerRef}
			gap={gap}
			className={className}
		>
			<Wrapper gap={gap}>
				{array.map((item, index) => (
					<div key={item.key}>{template(item, selected(item), index)}</div>
				))}
			</Wrapper>
		</StyledScrollWithSelected>
	);
};
